import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    options: {
        customProperties: true
    },
    theme: {
        themes: {
            light: {
                primary: '#FAB400',
                background: '#fafafa',
                secondary: '#b0bec5',
                accent: '#8c9eff',
                error: '#b71c1c',
                dark: '#2B2D2E',
            },
        },
    },
});
